import type { Dispatch, SetStateAction } from "react";
import type { FormType } from "../../components/types";

export const onAddPairingFormIncludeChip = (
  formIndex: number,
  values: string[],
  setForms: Dispatch<SetStateAction<FormType[]>>,
) => {
  setForms(state => {
    const copy: FormType[] = [...state];
    copy[formIndex].include = values;
    return copy;
  });
};
